module.exports = __webpack_public_path__ + "img/FoggyAndOnceRain.b91857a6.png";